import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { FilterTypeId, FILTER_TYPES } from "@/types/editor"

interface FilterFormProps {
  columnId: string
  filterType: FilterTypeId
  filterValue: string
  allKeys: string[]
  columnNames: Record<string, string>
  onColumnChange?: (col: string) => void
  onFilterTypeChange?: (type: FilterTypeId) => void
  onFilterValueChange?: (value: string) => void
  onApply: (col: string, type: FilterTypeId, value: string) => void
  onCancel: () => void
}

export function FilterForm({
  columnId,
  filterType,
  filterValue,
  allKeys,
  columnNames,
  onColumnChange,
  onFilterTypeChange,
  onFilterValueChange,
  onApply,
  onCancel,
}: FilterFormProps) {
  const handleApply = () => {
    if (!columnId) return
    onApply(columnId, filterType, filterValue)
  }

  return (
    <div className="space-y-2">
      <div>
        <Label className="text-[10px]">Column</Label>
        <Select
          value={columnId || undefined}
          onValueChange={(v) => {
            onColumnChange?.(v)
          }}
        >
          <SelectTrigger className="mt-0.5 h-7 w-full text-[11px]">
            <SelectValue placeholder="Select column" />
          </SelectTrigger>
          <SelectContent>
            {allKeys.map((k) => (
              <SelectItem className="text-xs" key={k} value={k}>
                {columnNames[k] ?? k}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-[10px]">Filter type</Label>
        <Select
          value={filterType}
          onValueChange={(v) => {
            onFilterTypeChange?.(v as FilterTypeId)
          }}
        >
          <SelectTrigger className="mt-0.5 h-7 w-full text-[11px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {FILTER_TYPES.map((t) => (
              <SelectItem className="text-xs" key={t.id} value={t.id}>
                {t.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {filterType !== "isEmpty" && filterType !== "isNotEmpty" && (
        <div>
          <Label className="text-[10px]">Value</Label>
          <Input
            value={filterValue}
            onChange={(e) => {
              onFilterValueChange?.(e.target.value)
            }}
            placeholder="Value"
            className="h-7 text-[11px]"
          />
        </div>
      )}
      <div className="flex gap-1">
        <Button size="sm" className="h-6 flex-1 text-[10px]" onClick={handleApply} disabled={!columnId}>
          Apply
        </Button>
        <Button size="sm" variant="outline" className="h-6 flex-1 text-[10px]" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
